import { render, staticRenderFns } from "./HostSeminar.vue?vue&type=template&id=f864044c"
import script from "./HostSeminar.vue?vue&type=script&lang=ts"
export * from "./HostSeminar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports